import { queryApi } from '../../../api'
import { ENDPOINT } from '../../../constants'
import { IVirksomhet } from '../../adresse/types'

export const orgformKodeApi = {
  get: (orgNr: string) =>
    queryApi.get<IVirksomhet>(
      `${ENDPOINT.VIRKSOMHET}/virksomheter/orgnummer/${orgNr}`
    ),
  getTilsynsobjektData: (tilsynsobjektId: string) =>
    queryApi.get<any>(
      `${ENDPOINT.TILSYNSOBJEKT}/tilsynsobjekter/id/${tilsynsobjektId}`
    ),
}
